/* eslint-disable no-console */
import { QueryStatus } from '@tanstack/react-query';
import getFdfApiCall, { GetFdfResponse } from 'api/calls/getFdfApiCall';
import useAuth from './useAuth';
import useProtectedQuery from './useProtectedQuery';

interface UseFdfQuery {
  status: QueryStatus;
  fdf?: GetFdfResponse;
}

const useFdfQuery = (enabled = true): UseFdfQuery => {
  const { token } = useAuth();
  const query = useProtectedQuery(['getFdfApiCall', token], getFdfApiCall, {
    enabled,
    retry: false,
    onError() {
      console.log('FDF was already requested');
    },
  });

  return {
    status: query.status,
    fdf: query.data,
  };
};

export default useFdfQuery;
